import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { hexToRgba } from '../../utils/colors';
import Button from '../Button';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      position: 'relative',
      '&:after, &:before': {
        content: "' '",
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        opacity: function opacity(_ref) {
          var open = _ref.open;
          return open ? 0 : 1;
        },
        transiton: 0.5
      },
      '&:after': {
        height: function height(_ref2) {
          var open = _ref2.open;
          return open ? 0 : '66%';
        },
        background: function background(_ref3) {
          var backgroundColor = _ref3.backgroundColor;
          return "linear-gradient(0deg, " + hexToRgba(backgroundColor, 1) + " 0%, " + hexToRgba(backgroundColor, 0) + " 100%)";
        }
      },
      '&:before': {
        height: function height(_ref4) {
          var lineHeight = _ref4.lineHeight;
          return lineHeight || 0;
        },
        background: function background(_ref5) {
          var backgroundColor = _ref5.backgroundColor;
          return "linear-gradient(90deg, " + hexToRgba(backgroundColor, 0) + " 0%, " + hexToRgba(backgroundColor, 1) + " 100%)";
        }
      }
    },
    icon: {
      transform: function transform(_ref6) {
        var open = _ref6.open;
        return open ? 'rotate(180deg)' : null;
      }
    },
    button: {
      textTransform: 'none',
      top: function top(_ref7) {
        var open = _ref7.open,
          lineHeight = _ref7.lineHeight;
        return !open && lineHeight > 0 ? 0 - lineHeight / 2 : 0;
      },
      backgroundColor: '#fff'
    }
  };
});
var CollapsedText = function CollapsedText(_ref8) {
  var children = _ref8.children,
    collapsedLines = _ref8.collapsedLines,
    lineHeight = _ref8.lineHeight,
    buttonLabel = _ref8.buttonLabel,
    backgroundColor = _ref8.backgroundColor,
    buttonJustify = _ref8.buttonJustify;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(100),
    collapsedSize = _useState2[0],
    setCollapsedSize = _useState2[1];
  var classes = useStyles({
    open: open,
    backgroundColor: backgroundColor,
    lineHeight: lineHeight,
    buttonJustify: buttonJustify
  });
  useEffect(function () {
    if (collapsedLines > 0 && lineHeight > 0) {
      setCollapsedSize(collapsedLines * lineHeight);
    }
  }, [collapsedLines, lineHeight]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Collapse, {
    collapsedSize: collapsedSize,
    in: open,
    className: classes.root
  }, children), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: buttonJustify
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primaryAlt",
    variant: "outlined",
    size: "small",
    onClick: function onClick() {
      return setOpen(!open);
    },
    className: classes.button,
    endIcon: buttonJustify === 'flex-end' ? /*#__PURE__*/React.createElement(KeyboardArrowDownIcon, {
      className: classes.icon
    }) : null,
    startIcon: buttonJustify !== 'flex-end' ? /*#__PURE__*/React.createElement(KeyboardArrowDownIcon, {
      className: classes.icon
    }) : null
  }, function () {
    if (buttonLabel && buttonLabel.open && buttonLabel.closed) {
      return open ? buttonLabel.open : buttonLabel.closed;
    }
    return open ? 'Less' : 'More';
  }()))));
};
CollapsedText.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @ignore
   */
  children: PropTypes.any.isRequired,
  /**
   * Number of lines to show
   */
  collapsedLines: PropTypes.number,
  /**
   *  The height of a line (used to create a gradient mask over the last line of text)
   */
  lineHeight: PropTypes.number,
  /**
   * Labels to show on the button when open and closed
   */
  buttonLabel: PropTypes.shape({
    open: PropTypes.string,
    closed: PropTypes.string
  }),
  /**
   * Used to create gradient masks to show the user that there is hidden text (6 character hex value)
   */
  backgroundColor: PropTypes.string,
  /**
   * Position for the button
   */
  buttonJustify: PropTypes.oneOf(['flex-start', 'center', 'flex-end'])
} : {};
CollapsedText.defaultProps = {
  collapsedLines: 0,
  lineHeight: 0,
  buttonLabel: null,
  backgroundColor: '#ffffff',
  buttonJustify: 'flex-start'
};
export default CollapsedText;